"use client";

import type { ReactNode } from "react";

interface ResumeTabHeaderV2Props {
  title: string;
  description?: string;
  action?: ReactNode;
}

export function ResumeTabHeaderV2({ title, description, action }: ResumeTabHeaderV2Props) {
  return (
    <div className="flex flex-wrap items-start justify-between gap-3">
      <div className="min-w-0">
        <h2 className="text-lg font-semibold tracking-tight text-slate-950 dark:text-white">
          {title}
        </h2>
        {description ? (
          <p className="mt-1 max-w-2xl text-sm leading-6 text-slate-600 dark:text-zinc-400">
            {description}
          </p>
        ) : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
